// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"30018":"87d5725ad6a940f2","42318":"8c68d6113632810f","42826":"21b79d6895508e9a","72338":"5550d1fae2d5e5e9","73915":"479cf45c3d30ff79"}[chunkId] + ".css";
};